import {useParams} from "react-router-dom";
import {BoardContainer, TitleContainer} from "../../assets/GlobalStyles";
import Notice from "./Notice";
import React from "react";
import NoticeDetail from "./NoticeDetail";

export default function Customer() {
  const params = useParams();
  return (
      <main>
        <BoardContainer>
          <TitleContainer>
            <div>
              <h1>고객 센터</h1>
            </div>
          </TitleContainer>
          {params.id === 'notice' && <Notice/>}
          {params.id === 'noticeDetail' && <NoticeDetail/>}
          {/*{params.id === 'inquiry' && <Inquiry/>}*/}
          {/*{params.id === 'inquiryDetail' && <InquiryDetail/>}*/}
        </BoardContainer>
      </main>
  )
}
